import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    container: {
      padding: '30px 25px 40px 25px',
    },
    leftText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
      color: '#2C2D3E',
      marginBottom: '4px'
    },
    rightText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      color: '#2C2D3E',
      marginBottom: '4px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    line: {
      position: 'relative',
      width: '100%',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
    },
    editIcon: {
      width: '15px',
      height: '15px',
      padding: '5px',
      color: 'rgba(44, 45, 62, 0.8)',
      cursor: 'pointer',
      '&:hover': {
        borderRadius: '60px',
        backgroundColor: '#CACAFCB2',
      },
    },
    authIcon: {
      width: '18px',
      height: '18px',
      padding: '5px',
      color: 'rgba(44, 45, 62, 0.8)',
      cursor: 'pointer',
      '&:hover': {
        borderRadius: '60px',
        backgroundColor: '#CACAFCB2',
      },
    },
    editIconContainer: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      bottom: '3px',
      alignSelf: 'center',
      justifyContent: 'flex-end',
      height: '100%',
      zIndex: 2,
    },
    item: {
      display: 'flex',
      width: '100%',
      height: '25px',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
  }),
);